module.exports = __webpack_public_path__ + "img/about.7a22990b.png";